const initialState = {
  data: null,
  loading: false,
  dismissed: false,
};

export const sellerOnboarding = (state = initialState, action) => {
  switch (action.type) {
    case "GET_SELLER_ONBOARDING_STATUS_REQUEST":
      return { ...state, loading: true };
    case "GET_SELLER_ONBOARDING_STATUS":
      return { ...state, data: action.payload, loading: false };
    case "GET_SELLER_ONBOARDING_STATUS_FAILURE":
      return { ...state, loading: false };
    case "DISMISS_SELLER_ONBOARDING":
      return { ...state, dismissed: true };
    case "SELLER_ONBOARDING_COMPLETE":
      return {
        ...state,
        data: state.data
          ? { ...state.data, seller_onboarding_completed: true, percentage: action.payload.percentage }
          : state.data,
      };
    default:
      return state;
  }
};
